import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { cancelarAlert } from 'app/services/alerts';
import { usuarioApi } from 'app/services/api/usuarioApi';
import authService from 'app/services/authService';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { FormikProvider, useFormik } from 'formik';
import jwtDecode from 'jwt-decode';
import React, { useContext, useState } from 'react';
import { FaKey } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { LoginModais } from '../LoginModais';
import Content from './formulario/Content';
import AlterarSenhaSchema from './schemas/AlterarSenhaSchema';

const AlterarSenhaModal = () => {
  const [modal, setModal] = useContext(GlobalContext).modal;
  const token = authService.getAccessToken();
  const decodedToken = jwtDecode(token);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useReduxLoading(loading);

  const registro = {
    nome: decodedToken.name,
    email: decodedToken.email,
    senhaAtual: '',
    novaSenha: '',
    confirmarNovaSenha: '',
  };

  const handleCloseModal = () => {
    const close = () => {
      formik.resetForm(registro);
      setModal(false);
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const showMessage = (message, variant) => {
    dispatch(
      Actions.showMessage({
        message,
        variant,
      })
    );
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    const dados = {
      senhaAtual: values.senhaAtual,
      novaSenha: values.novaSenha,
    };

    try {
      eventReactGA('Usuário', 'Alterar senha');
      await usuarioApi.alterarSenhaUsuarioKeycloak(dados);

      showMessage('Senha editada com sucesso.', 'success');
      setLoading(false);
      setModal(false);
    } catch (err) {
      setLoading(false);
      apiUtils.handleApiError(err);
    }
  };

  const formik = useFormik({
    validationSchema: AlterarSenhaSchema,
    initialValues: registro,
    onSubmit: handleSubmit,
    validateOnChange: true,
    validateOnBlur: true,
  });

  return (
    <SimpleDialog open={modal === LoginModais.alterarSenha} onClose={handleCloseModal}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Alterar senha',
            icon: <FaKey />,
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCloseModal}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          content={<Content />}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default AlterarSenhaModal;
